import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { adminApi, fmtErr } from "../api";
import { AdminAuthShell } from "../components";

const GENERIC = "If an account exists for this email, a password reset link has been sent.";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await adminApi.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      const d = err?.response?.data?.detail;
      if (err?.response?.status === 422) setDone(true);
      else setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminAuthShell>
      <div className="bg-white p-8 rounded-sm shadow-2xl" data-testid="forgot-password-form">
        <h1 className="font-display text-lg font-bold text-slate-900 flex items-center gap-2"><MailCheck size={16} className="text-[#C5221F]" /> Reset Password</h1>
        {done ? (
          <div className="mt-5">
            <p className="text-sm text-slate-700 leading-relaxed bg-slate-50 border border-slate-200 px-4 py-3.5 rounded-sm" data-testid="forgot-success-msg">{GENERIC}</p>
            <p className="mt-3 text-xs text-slate-500">The link is valid for 30 minutes.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <p className="text-xs text-slate-500">Enter your registered staff email. We will send a secure reset link.</p>
            <div>
              <label htmlFor="fp-email" className="block text-[11px] font-bold uppercase tracking-widest text-slate-500 mb-1.5">Email Address</label>
              <input id="fp-email" type="email" required autoComplete="email" data-testid="forgot-email-input"
                className="w-full border border-slate-300 px-3.5 py-2.5 text-sm rounded-sm focus:outline-none focus:border-[#C5221F] focus:ring-1 focus:ring-[#C5221F]"
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@grengg.com" />
            </div>
            {error && <p className="text-xs text-[#C5221F] bg-red-50 border border-red-200 px-3 py-2.5 rounded-sm" data-testid="forgot-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="forgot-submit-btn"
              className="w-full bg-[#C5221F] hover:bg-[#A81B18] disabled:opacity-60 text-white font-display font-semibold py-3 text-xs uppercase tracking-widest rounded-sm transition-colors duration-150 inline-flex items-center justify-center gap-2">
              {busy && <Loader2 size={14} className="animate-spin" />} Send Reset Link
            </button>
          </form>
        )}
        <Link to="/admin" className="mt-5 flex items-center justify-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-slate-500 hover:text-[#C5221F] transition-colors" data-testid="forgot-back-link">
          <ArrowLeft size={12} /> Back to Sign In
        </Link>
      </div>
    </AdminAuthShell>
  );
};

export default ForgotPassword;
